import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import '../src/assets/css/main.css'

const app = createApp(App)

app.config.productionTip = false
app.config.errorHandler = function (err, _vm, info) {
  console.error('Global Error Handler:', err, info)
}

app.use(router).use(store).mount('#app')
